// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// const Bootstrap = require('bootstrap')
// const Popper = require('popper.js')
import 'bootstrap'
import 'popper.js'

// const _ = require('lodash');

import lodash from 'lodash';    
Object.defineProperty(Vue.prototype, '$lodash', { value: lodash });


import jQuery from 'jquery'
global.jQuery = jQuery

import 'bootstrap/dist/css/bootstrap.css'
// import store from './vuex'

import Vuex from 'vuex';  

import VuexStore from './vuex/store/store';  

Vue.use(Vuex);  

const store = new Vuex.Store(VuexStore);


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  // components: { App },
  // template: '<App/>',
  render: h => h (App) 
})



// WEBPACK FOOTER //
// ./src/main.js